import Cookies from 'js-cookie';

// Suffix of the B2B GA4 Measurement ID G-M1VJVSX2T9 (the part after `G-`). The GA4 session id lives
// in the `_ga_<suffix>` cookie which, unlike sessionStorage, survives the marketing-domain →
// connect-subdomain hop (cookies are scoped to the registrable domain). We fall back to the
// GTM-written sessionStorage value if the cookie is absent, still normalised for format.
const GA4_MEASUREMENT_SUFFIX = 'M1VJVSX2T9';

const GA_SESSION_STORAGE_KEY = 'ga_session_id';
const GCL_AW_COOKIE = '_gcl_aw';

// Extracts the GA4 session id from a `_ga_<id>` cookie value (or the GTM-written sessionStorage
// tail). GA4 stores far more than the session id in that value and the format is not what
// Salesforce expects, so we pull out just the numeric session id.
export const parseGaSessionId = (raw: string | undefined | null): string => {
  if (!raw) {
    return '';
  }
  // GS2 format: `GS2.1.s1784218545$o1$g0$t...` (also matches the bare GTM tail `s1784218545$o...`).
  const gs2 = raw.match(/s(\d+)/);
  if (gs2) {
    return gs2[1];
  }
  // GS1 format: `GS1.1.1784218545.1.1.<...>` — the session id is the third dot-separated segment.
  const parts = raw.split('.');
  if (parts.length >= 3 && /^\d+$/.test(parts[2])) {
    return parts[2];
  }
  return '';
};

// Extracts the gclid from a `_gcl_aw` cookie value of the form `GCL.<timestamp>.<gclid>`.
export const parseGclid = (raw: string | undefined | null): string => {
  if (!raw) {
    return '';
  }
  const parts = raw.split('.');
  return parts.length >= 3 ? parts.slice(2).join('.') : '';
};

export const getGaSessionId = (): string => {
  const fromCookie = GA4_MEASUREMENT_SUFFIX
    ? Cookies.get(`_ga_${GA4_MEASUREMENT_SUFFIX}`)
    : undefined;
  return parseGaSessionId(
    fromCookie ?? sessionStorage.getItem(GA_SESSION_STORAGE_KEY),
  );
};

export const getGclid = (): string => parseGclid(Cookies.get(GCL_AW_COOKIE));
